import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

export function scrollToPageTop(top = 0, behavior = 'auto') {
  try {
    window.scroll({
      top: top,
      left: 0,
      behavior,
    });
  } catch (error) {
    window.scrollTo(0, top);
  }
}

export function scrollToElement(
  element,
  options = {
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  }
) {
  if (element?.current) {
    element?.current?.scrollIntoView(options);
  } else {
    element?.scrollIntoView(options);
  }
}

// eslint-disable-next-line react/display-name
export const GetForwardRef = forwardRef((props, ref) => {
  return (
    <div ref={ref}>
      {React.Children.map(props.children, (child) => {
        return React.cloneElement(child, { forwardRef: ref });
      })}
    </div>
  );
});

GetForwardRef.propTypes = {
  children: PropTypes.object
};
